import { Injectable } from '@angular/core';
import { Observable, TeardownLogic } from 'rxjs';

import { GeolocationOptions, GeolocationPosition } from '../models';

/**
 *  Motes geolocation wrapper
 *
 */
@Injectable({ providedIn: 'root' })
export abstract class MotesGeolocation {
    abstract getCurrentPosition(options?: GeolocationOptions): Promise<GeolocationPosition | GeolocationPositionError>;
    abstract watchPosition(options?: GeolocationOptions): Observable<GeolocationPosition | GeolocationPositionError>;
    abstract getPermissions(): Promise<PermissionState>;
}
/**
 * Test stub for geolocation service
 */
export class MotesGeolocationStub implements MotesGeolocation {
    getCurrentPosition(options?: GeolocationOptions): Promise<GeolocationPosition> {
        return new Promise(resolve => {
            resolve({
                timestamp: 0, coords: {
                    latitude: 0, longitude: 0, accuracy: 0, altitude: 0, altitudeAccuracy: 0, heading: 0, speed: 0,
                }
            })
        })
    };

    watchPosition(options?: GeolocationOptions): Observable<GeolocationPosition> {
        return new Observable(() => {
        });
    }

    async getPermissions(): Promise<PermissionState>{
        return 'granted';
    }
}

@Injectable()
export class MotesGeolocationBrowser implements MotesGeolocation {
    getCurrentPosition(options?: GeolocationOptions): Promise<GeolocationPosition | GeolocationPositionError> {
        return new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition((pos) => {
                resolve(pos);
            }, (err) => { console.log(err); reject(err) }, options);
        });
    };

    watchPosition(options?: GeolocationOptions): Observable<GeolocationPosition> {
        return new Observable((obs) => {
            // Watch position
            let watchId = navigator.geolocation.watchPosition((pos) => {
                obs.next(pos);
            }, err => { console.error(err) }, options);

            // Clear geolocation watch on unsubscribe
            let tearDown: TeardownLogic = () => {
                navigator.geolocation.clearWatch(watchId);
            }
            return tearDown;
        });
    }

    async getPermissions(): Promise<PermissionState> {
        const permissions = await navigator.permissions?.query({name:'geolocation'});
        return permissions?.state || 'prompt';
    }
}
